/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-const */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/order */
/* eslint-disable object-shorthand */
/* eslint-disable prettier/prettier */
import { Icon } from '@iconify/react';
import { useEffect, useRef, useState } from 'react';
import skipBackOutline from '@iconify/icons-eva/skip-back-outline';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
// material
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  TextField,
  Grid,
  CardHeader,
  SpeedDial,
  SpeedDialIcon,
  SpeedDialAction,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
// components
import Page from '../components/Page';
import { useFormik } from 'formik';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// eslint-disable-next-line import/no-named-as-default-member
import MyDropzone from 'src/components/MyDropzone';
import axios from 'axios';
import { config } from 'src/helpers/config';
import SaveIcon from '@mui/icons-material/Save';
import authHeader from 'src/helpers/authHeader';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import 'react-datepicker/dist/react-datepicker.css';
import { NotificationManager } from 'react-notifications';
import { countries } from 'src/utils/constantData';
import CropImageDialog from 'src/components/dialogs/CropImageDialog';

const validationSchema = yup.object({
  title: yup.string('Wprowadź tytuł').required('To pole jest obowiązkowe'),
  shortDescription: yup.string('Wprowadź tytuł').required('To pole jest obowiązkowe')
});

export default function Trip() {
  const [deletedFiles, setDeletedFiles] = useState([]);
  const [position, setPosition] = useState({
    x: 0,
    y: 0
  });
  const [startDate, setStartDate] = useState(new Date());
  const [files, setFiles] = useState([]);
  const [selectedImage, setSelectedImage] = useState(0);
  const [progress, setProgress] = useState(0);
  const [cropper, setCropper] = useState({
    isOpen: false,
    image: '',
    file: null
  });
  const { id } = useParams();

  const mapContainerRef = useRef(null);
  const markerRef = useRef(null);

  let navigate = useNavigate();

  useEffect(() => {
    console.log(cropper);
  }, [cropper]);

  const onUploadProgress = (progressEvent) => {
    const { loaded, total } = progressEvent;
    let percent = Math.floor((loaded * 100) / total);
    if (percent <= 100) {
      console.log(percent);
    }
  };

  const formik = useFormik({
    initialValues: {
      title: '',
      description: '',
      city: '',
      shortDescription: '',
      videoId: '',
      kilometers: 0,
      refueling: 0,
      people: 0
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log(values);
      const formData = new FormData();
      files.map((file) => formData.append('images', file));
      formData.append('title', values.title);
      formData.append('shortDescription', values.shortDescription);
      formData.append('description', values.description);
      formData.append('city', values.city);
      formData.append('videoId', values.videoId);
      formData.append('x', position.x.toString());
      formData.append('y', position.y.toString());
      formData.append('defaultImageIndex', selectedImage);
      formData.append('dateOfTheVisit', startDate.toUTCString());
      formData.append('people', values.people);
      formData.append('kilometers', values.kilometers);
      formData.append('refueling', values.refueling);
      formData.append('miniatureImg', cropper.file);

      if (id) {
        deletedFiles.map((id) => formData.append('deletedImages', id));
        formData.append('id', id);
        axios
          .put(`${config.apiAdminUrl}trip`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              ...authHeader()
            },
            onUploadProgress
          })
          .then(() => {
            NotificationManager.success('Wizyta została zautualizowana!', '', 3000);
            navigate('/dashboard/trips');
          })
          .catch((e) => {
            console.log(e.response);
            NotificationManager.error('Wystąpił jakiś błąd! Skontaktuj się z Łukaszem!', '', 3000);
          });
      } else {
        axios
          .post(`${config.apiAdminUrl}trip`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              ...authHeader()
            },
            onUploadProgress
          })
          .then(() => {
            NotificationManager.success('Wizyta została dodana!', '', 3000);
            navigate('/dashboard/trips');
          })
          .catch((e) =>
            NotificationManager.error('Wystąpił jakiś błąd! Skontaktuj się z Łukaszem!', '', 3000)
          );
      }
    }
  });

  useEffect(() => {
    if (id) {
      axios
        .get(`${config.apiAdminUrl}trip/${id}`, {
          headers: { ...authHeader() }
        })
        .then((e) => {
          const visit = e.data.result;
          formik.setValues({
            title: visit.title,
            description: visit.description,
            city: visit.city,
            shortDescription: visit.shortDescription,
            videoId: visit.videoId,
            kilometers: visit.kilometers,
            people: visit.people,
            refueling: visit.refueling
          });
          let _files = [];
          visit.images.map((e) =>
            _files.push({ id: e.item2, preview: `${config.filesUrl}${e.item1}` })
          );

          setFiles(_files);
          setStartDate(new Date(visit.dateOfTheVisit));
          setPosition({
            x: visit.x,
            y: visit.y
          });
        });
    }
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Page title="User | Minimal-UI">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Wizyta
            </Typography>
            <span>
              <Button
                sx={{
                  marginRight: '5px'
                }}
                variant="contained"
                component={RouterLink}
                to="/dashboard/trips"
                startIcon={<Icon icon={skipBackOutline} />}
              >
                Wróć
              </Button>
            </span>
          </Stack>
          <Card
            sx={{
              padding: '25px'
            }}
          >
            <form onSubmit={formik.handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    size="small"
                    fullWidth
                    id="title"
                    name="title"
                    label="Tytuł"
                    value={formik.values.title}
                    onChange={formik.handleChange}
                    error={formik.touched.title && Boolean(formik.errors.title)}
                    helperText={formik.touched.title && formik.errors.title}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    size="small"
                    fullWidth
                    id="shortDescription"
                    name="shortDescription"
                    label="Krótki opis"
                    maxRows={5}
                    rows={3}
                    multiline
                    value={formik.values.shortDescription}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.shortDescription && Boolean(formik.errors.shortDescription)
                    }
                    helperText={formik.touched.shortDescription && formik.errors.shortDescription}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    size="small"
                    fullWidth
                    id="videoId"
                    name="videoId"
                    label="VideoId"
                    value={formik.values.videoId}
                    onChange={formik.handleChange}
                    error={formik.touched.videoId && Boolean(formik.errors.videoId)}
                    helperText={formik.touched.videoId && formik.errors.videoId}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Kraj</InputLabel>
                    <Select
                      labelId="country-select-label"
                      defaultValue="Polska"
                      id="country-select"
                      size="small"
                      value={formik.values.country}
                      label="Kraj"
                      onChange={formik.handleChange}
                    >
                      {countries.map((e, index) => (
                        <MenuItem key={`country-${index}`} value={e.value}>
                          {e.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {/* STATS */}
                <Grid item xs={12}>
                  <CardHeader
                    sx={{
                      padding: '0px',
                      marginBottom: '5px'
                    }}
                    title="Statystyka"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    type="number"
                    size="small"
                    fullWidth
                    id="kilometers"
                    name="kilometers"
                    label="Przejechane kilometry"
                    value={formik.values.kilometers}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    type="number"
                    size="small"
                    fullWidth
                    id="people"
                    name="people"
                    label="Ewangelizowane osoby"
                    value={formik.values.people}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    type="number"
                    size="small"
                    fullWidth
                    id="refueling"
                    name="refueling"
                    label="Ilość tankowań"
                    value={formik.values.refueling}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CardHeader
                    sx={{
                      padding: '0px',
                      marginBottom: '5px'
                    }}
                    title="Opis"
                  />
                  <CKEditor
                    editor={ClassicEditor}
                    data={formik.values.description}
                    config={{
                      ckfinder: {
                        // Upload the images to the server using the CKFinder QuickUpload command.
                        uploadUrl: `${config.apiAdminUrl}image`,
                        headers: { ...authHeader() }
                      }
                    }}
                    onReady={(editor) => {
                      // You can store the "editor" and use when it is needed.
                      console.log('Editor is ready to use!', editor);
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      formik.setFieldValue('description', data);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CardHeader
                    sx={{
                      padding: '0px',
                      marginBottom: '5px'
                    }}
                    title="Dane wizyty i lokalizacja"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    fullWidth
                    id="city"
                    name="city"
                    label="Miasto"
                    value={formik.values.city}
                    onChange={formik.handleChange}
                    error={formik.touched.city && Boolean(formik.errors.city)}
                    helperText={formik.touched.city && formik.errors.city}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <DesktopDatePicker
                    label="Data wizyty"
                    inputFormat="MM/dd/yyyy"
                    value={startDate}
                    onChange={(date) => setStartDate(date)}
                    renderInput={(params) => <TextField size="small" {...params} />}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      width: {
                        sm: '100%',
                        md: '60%'
                      }
                    }}
                    component="div"
                    style={{
                      position: 'relative'
                    }}
                    ref={mapContainerRef}
                    onClick={(e) => {
                      const { current } = mapContainerRef;
                      const mapContainer = {
                        y: current.clientHeight,
                        x: current.clientWidth
                      };
                      console.log(mapContainerRef);

                      setPosition({
                        x: Number(((e.nativeEvent.offsetX * 100) / mapContainer.x).toFixed(2)),
                        y: Number(((e.nativeEvent.offsetY * 100) / mapContainer.y).toFixed(2))
                      });
                    }}
                  >
                    <img src="/static/map.svg" />
                    <img
                      ref={markerRef}
                      style={{
                        left: markerRef.current
                          ? `calc(${position.x}% - ${markerRef.current.clientWidth / 2}px)`
                          : 0,
                        top: markerRef.current
                          ? `calc(${position.y}% - ${markerRef.current.clientHeight}px)`
                          : 0,
                        position: 'absolute',
                        width: '30px'
                      }}
                      src="/static/icons/marker.svg"
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={(e) => {
                      if (e.target.files) {
                        setCropper({
                          image: URL.createObjectURL(e.target.files[0]),
                          isOpen: true
                        });
                      }
                    }}
                  />
                  <CropImageDialog
                    open={cropper.isOpen}
                    image={cropper.image}
                    handleClose={() =>
                      setCropper({
                        ...cropper,
                        isOpen: false
                      })
                    }
                    handleFile={(_file) =>
                      setCropper({
                        ...cropper,
                        isOpen: false,
                        file: _file
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <MyDropzone
                    multiple
                    files={files}
                    handleFiles={(e) => setFiles(e)}
                    selectedIndex={selectedImage}
                    handleSelected={(e) => setSelectedImage(e)}
                    handleDeletedFiles={(e) => {
                      let _deletedFiles = deletedFiles;
                      _deletedFiles.push(e);
                      setDeletedFiles(_deletedFiles);
                    }}
                  />
                </Grid>
                <SpeedDial
                  ariaLabel="SpeedDial basic example"
                  sx={{ position: 'fixed', bottom: 16, right: 16 }}
                  icon={<SpeedDialIcon />}
                >
                  <SpeedDialAction
                    component={Button}
                    type="submit"
                    icon={<SaveIcon />}
                    tooltipTitle="Zapisz"
                  />
                </SpeedDial>
              </Grid>
            </form>
          </Card>
        </Container>
      </Page>
    </LocalizationProvider>
  );
}
